export const CONTENT_CACHE_INVALIDATE = 'CONTENT_CACHE_INVALIDATE';
export const CONTENT_CACHE_INVALIDATE_ALL = 'CONTENT_CACHE_INVALIDATE_ALL';
